const CHECKOUT_SRC = "https://checkout.razorpay.com/v1/checkout.js";
let loader = null;

const loadCheckout = () => {
  if (window.Razorpay) return Promise.resolve();
  loader = loader || new Promise((resolve, reject) => {
    const s = document.createElement("script");
    s.src = CHECKOUT_SRC;
    s.onload = resolve;
    s.onerror = () => { loader = null; reject(new Error("Could not load Razorpay. Check your connection and try again.")); };
    document.body.appendChild(s);
  });
  return loader;
};

// Opens Razorpay Checkout for a server-created order; resolves with ids for server-side verification.
export async function collectPayment(order, { description, prefill } = {}) {
  if (order.mock) {
    await new Promise((r) => setTimeout(r, 1200));
    return { gateway_order_id: order.order_id, gateway_payment_id: "pay_mock_" + Math.random().toString(36).slice(2, 10), signature: "mock_sig" };
  }
  await loadCheckout();
  return new Promise((resolve, reject) => {
    const rzp = new window.Razorpay({
      key: order.key, order_id: order.order_id, amount: order.amount * 100, currency: order.currency || "INR",
      name: "Karmivo", description, prefill, theme: { color: "#f97316" },
      handler: (r) => resolve({ gateway_order_id: r.razorpay_order_id, gateway_payment_id: r.razorpay_payment_id, signature: r.razorpay_signature }),
      modal: { ondismiss: () => reject(new Error("Payment cancelled")) },
    });
    rzp.open();
  });
}
